export * from './app-config';
export * from './core.module';

/**
 *
 * This folder contains the core functionality and services that are fundamental to the application's operation.
 * It often includes services related to authentication, HTTP requests, state management, and other essential features.
 * The core folder helps maintain a separation of concerns and provides a foundation for the entire application.
 */
